module.exports = __webpack_public_path__ + "img/location-pin-b.783308e2.png";